export type ReviewStatus = 'draft' | 'submitted' | 'acknowledged';

export const REVIEW_STATUSES: { value: ReviewStatus; label: string }[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'acknowledged', label: 'Acknowledged' },
];

export const REVIEW_STATUS_LABEL: Record<ReviewStatus, string> = Object.fromEntries(
  REVIEW_STATUSES.map((s) => [s.value, s.label]),
) as Record<ReviewStatus, string>;

export const reviewStatusLabel = (s: string): string =>
  REVIEW_STATUSES.find((x) => x.value === s)?.label ?? s;

export function reviewStatusVariant(
  s: string,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'draft') return 'outline';
  if (s === 'submitted') return 'secondary';
  if (s === 'acknowledged') return 'default';
  return 'outline';
}
